import { ProductFlowFooter } from '@/routes/Public/marketing/components/ProductFlowFooter'
import { SiteFooter } from '@/routes/Public/marketing/components/SiteFooter'
import { ESTIMATE_BANNER_COPY } from '@/routes/Public/marketing/content/estimateBannerCopy'
import { Demo, DsSection } from '../primitives'

export function FooterSection() {
  return (
    <DsSection id="footer" title="Footer" marketing>
      <Demo label="SiteFooter" className="-mx-8 overflow-hidden rounded-sm md:-mx-12">
        <SiteFooter
          tagline="Financial technology to empower the businesses that build, move, and fix the world around us."
          linkColumns={[
            {
              heading: 'Company',
              links: [
                { label: 'About', href: '#footer' },
                { label: 'Blog', href: '#footer' },
              ],
            },
            {
              heading: 'Products',
              links: [
                { label: 'Insurance', href: '#footer' },
                { label: 'FuelApp', href: '#footer' },
                { label: 'Compliance', tag: 'Coming soon' },
              ],
            },
            {
              heading: 'Connect',
              links: [
                { label: 'LinkedIn', href: '#footer', external: true },
                { label: 'Facebook', href: '#footer', external: true },
                { label: 'Instagram', href: '#footer', external: true },
                { label: 'X', href: '#footer', external: true },
              ],
            },
          ]}
          legalLinks={[
            { label: 'Privacy Policy', href: '#footer' },
            { label: 'Terms of Service', href: '#footer' },
          ]}
          note={
            <>
              <p>
                Insurance services provided by Cai Insurance Services, a service of Cai Labs, Inc. Agency
                License #6018835. Descriptions are general in nature only. Please refer to the terms and
                conditions of any policies offered or purchased. Insurance products offered are subject to
                application and underwriting requirements. Not all products available in all states. Pricing
                depends on a variety of factors including policyholder location. Not all discounts available
                in all states or on all products.
              </p>
              <p>
                If you are having difficulty viewing or navigating the content on this website, or find a
                feature or functionality that is not fully accessible to you, please email us at{' '}
                <a href="mailto:hello@cai.ai">hello@cai.ai</a>.
              </p>
            </>
          }
          estimateBanner={{
            description: ESTIMATE_BANNER_COPY.description,
            buttonLabel: ESTIMATE_BANNER_COPY.buttonLabel,
            buttonLabelMobile: ESTIMATE_BANNER_COPY.buttonLabelMobile,
            onSubmit: () => undefined,
          }}
        />
      </Demo>
      <Demo label="Product flow — stripped-back footer for the DOT funnel/estimate results">
        <ProductFlowFooter
          legalLinks={[
            { label: 'Privacy Policy', href: '#footer' },
            { label: 'Terms of Service', href: '#footer' },
          ]}
          note={
            <>
              <p>
                Insurance services provided by Cai Insurance Services, a service of Cai Labs, Inc. Agency
                License #6018835. Descriptions are general in nature only. Please refer to the terms and
                conditions of any policies offered or purchased. Insurance products offered are subject to
                application and underwriting requirements. Not all products available in all states. Pricing
                depends on a variety of factors including policyholder location. Not all discounts available
                in all states or on all products.
              </p>
              <p>
                If you are having difficulty viewing or navigating the content on this website, or find a
                feature or functionality that is not fully accessible to you, please email us at{' '}
                <a href="mailto:hello@cai.ai">hello@cai.ai</a>.
              </p>
            </>
          }
        />
      </Demo>
    </DsSection>
  )
}
